import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useMutation } from 'react-query'
import { BrandPlan } from 'types'
import { useCurrentWorkspaceId } from './useCurrentWorkspaceId'
import { FormValues } from 'components/AutopilotFreemiumChannelSelectModal/types'

type DowngradeBrandPlanParams = FormValues & { price_id: string | null; payment_method_id?: string | null }

const downgradeBrandPlan = async ({
  workspaceId,
  params,
  signal,
}: {
  workspaceId: number
  params: DowngradeBrandPlanParams
  signal?: AbortSignal
}) => {
  const res = await sendToApi<{ brand_plan: BrandPlan }>(`/w/${workspaceId}/brand_plans/downgrade`, {
    body: params,
    method: 'POST',
    signal,
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data.brand_plan
}

export const useDowngradeBrandPlan = () => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation((params: DowngradeBrandPlanParams) => downgradeBrandPlan({ workspaceId, params }))
}
